/* eslint-disable sort-keys */
export default {
  light: {
    "banner-with-card-text-background": "white",
    "error-placement-background": "neutral-800",
    "error-placement-text-disabled": "neutral-500",
    "footer-content": "blue-1",
    "primary-header-background": "white",
    "primary-header-heading-icon": "gray-4",
    "primary-header-logo": "blue-1",
    "primary-header-logo-light": "white",
    "primary-header-search": "blue-1",
    "primary-header-search-open": "white",
    "secondary-header-border": "blue-1",
    "secondary-header-logo": "white",
    "secondary-header-logo-section-background": "blue-1",
    "secondary-header-options-background": "white",
    "secondary-header-title-section-background": "blue-2",
    "system-message-alert-background": "white",
    "system-message-alert-icon": "blue-1",
    "system-message-background": "primary-950",
    "system-message-border": "primary-900",
    "system-message-list-item-divider": "gray-3",
    "text-block-text-light": "neutral-900",
  },
  dark: {},
};
